/* eslint-disable import/prefer-default-export */
/**
 * Censors an email address for display according to the pattern:
 * Shows first N characters of local part, fixed asterisks, @,
 * first M characters of domain name, fixed asterisks, TLD.
 * Example: joseph@dreamstartlabs.com -> jose*******@dream**.com
 *
 * @param number Email to be censored
 * @returns {string | null} Censored email
 */
const censorEmail = (email: string): string => {
  if (!email || typeof email !== 'string' || !email.includes('@')) {
    return email || '';
  }

  const [localPart, domainPart] = email.split('@');

  if (!localPart || !domainPart) {
    return email;
  }

  // --- Censor local part ---
  const revealLocalEnd = Math.ceil(localPart.length * 0.5);
  const hiddenLocalLength = localPart.length - revealLocalEnd;
  const censoredLocal =
    hiddenLocalLength > 0
      ? `${localPart.slice(0, revealLocalEnd)}${'*'.repeat(hiddenLocalLength)}`
      : localPart;

  // --- Censor domain part ---
  const lastDotIndex = domainPart.lastIndexOf('.');
  let censoredDomain = '';

  // Check if there's a dot and it's not the first or last character
  if (lastDotIndex > 0 && lastDotIndex < domainPart.length - 1) {
    const domainName = domainPart.slice(0, lastDotIndex);
    const tld = domainPart.slice(lastDotIndex);

    const revealDomainEnd = Math.ceil(domainName.length * 0.5);
    const hiddenDomainLength = domainName.length - revealDomainEnd;

    const censoredDomainName =
      hiddenDomainLength > 0
        ? `${domainName.slice(0, revealDomainEnd)}${'*'.repeat(
            hiddenDomainLength
          )}`
        : domainName;

    censoredDomain = censoredDomainName + tld;
  } else {
    const revealDomainEnd = Math.ceil(domainPart.length * 0.5);
    const hiddenDomainLength = domainPart.length - revealDomainEnd;

    censoredDomain =
      hiddenDomainLength > 0
        ? `${domainPart.slice(0, revealDomainEnd)}${'*'.repeat(
            hiddenDomainLength
          )}`
        : domainPart;
  }

  return `${censoredLocal}@${censoredDomain}`;
};

export { censorEmail };
